module.exports = __webpack_public_path__ + "img/LOGO_SCT.baf995e1.png";